import { RESOURCE_NAME } from '@esentai/core/features/reconciliationPeriodBonusDetails/consts';
import { canCreate, canRead, canUpdate } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

export const canReadReconciliationPeriodBonusDetails = authorizeIf(
  canRead(RESOURCE_NAME),
);
export const canCreateReconciliationPeriodBonusDetails = authorizeIf(
  canCreate(RESOURCE_NAME),
);
export const canUpdateReconciliationPeriodBonusDetails = authorizeIf(
  canUpdate(RESOURCE_NAME),
);
